module.exports = __webpack_public_path__ + "img/logo.71186b29.png";